module.exports = __webpack_public_path__ + "static/img/logo19.30e1e66.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo19.png
// module id = Skv9
// module chunks = 1